import React from 'react';
import styles from './Footer.module.scss';

const Footer = () => (
    <div className={styles.footer}>Copyright © {new Date().getFullYear()} Quantam. All rights reserved.</div>
);

export default Footer;
